$(document).on "turbolinks:load", ->
  debounceTimer = null

  $("#live-search-field").on "keyup", ->
    clearTimeout(debounceTimer)

    debounceTimer = setTimeout =>
      field = $(this)
      val = field.val()

      if !val? or val.length < 2
        window.bootstrap.Popover.getInstance(field[0])?.hide()
        return

      form = $("#live-search-form")
      url = form.attr('action')
      formData = form.serialize()

      $.get(url, formData, (html) ->
        $.fn.popover.Constructor.Default.allowList.table = ['style']
        $.fn.popover.Constructor.Default.allowList.tr =
          [
            'assignment-id',
            'due_date',
            'style',
            'tabindex',
            'onkeypress'
          ]
        $.fn.popover.Constructor.Default.allowList.td = []
        $.fn.popover.Constructor.Default.allowList.tbody = []
        $.fn.popover.Constructor.Default.allowList.thead = []

        fieldEl = field[0]
        popoverInstance = window.bootstrap.Popover.getInstance(fieldEl)

        tempDiv = $("<div>").html(html)
        hasEntries = $(".live-search-entry", tempDiv).length > 0

        if popoverInstance and $("#live-search-container .popover-body").length > 0
          $("#live-search-container .popover-body").html(html)
        else
          popoverInstance = new window.bootstrap.Popover(fieldEl,
            html: true
            container: "#live-search-container"
            content: html
            trigger: "manual"
            placement: "bottom"
            template: '<div class="popover live-search-popover mt-0 live-search-popover-sizing" role="tooltip" style="max-width: 500px !important;min-width:100%;max-height: 500px;overflow-y: scroll;"><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
          )
          if hasEntries
            popoverInstance.show()

        unless hasEntries
          popoverInstance?.hide()

        $(".live-search-entry").each ->
          assignment_id = $(this).attr('assignment-id')
          if $("#calendar-entry-" + assignment_id).length > 0
            $(this).on 'click', ->
              window.bootstrap.Popover.getInstance($("#live-search-field")[0])?.hide()
              $('[data-bs-toggle="popover"]').each (i, el) ->
                window.bootstrap.Popover.getInstance(el)?.hide()
                $("#live-search-field").val("")
                popoverInstance._config.content = ''
                popoverInstance.update()
              $("#calendar-entry-" + assignment_id).popover('show')
          else
            $(this).on 'click', ->
              current_url = document.location.href
              target_url = current_url.replace(/&?start_date=([^&]$|[^&]*)/i, "").replace(/&?assignment_id=([^&]$|[^&]*)/i, "")
              if target_url.indexOf("?") == -1
                target_url += "?start_date=#{ $(this).attr('due_date') }&assignment_id=#{ assignment_id }"
              else
                target_url += "&start_date=#{ $(this).attr('due_date') }&assignment_id=#{ assignment_id }"
              document.location.href = target_url
      )
    , 250

  $("#live-search-field").on "blur", ->
    popoverInstance = window.bootstrap.Popover.getInstance($("#live-search-field")[0])
    popoverInstance?.hide()
    $("#live-search-field").val("")
    popoverInstance?._config.content = ''
    popoverInstance?.update()
